import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
  }

  button = document.getElementById('btn')
  
  search ="";


  searchUser(){
    this.search=(document.getElementById('search') as HTMLInputElement).value;
  }

}
